export default __webpack_public_path__ + "img/TourStep4-d05588822c45eadc01cb4af84216a038.png";